module.exports = {
  eventId: 'zdhPcnN8ZYyTtncwOrF5',
  accountId: 'rqPbvpK7wEHmEQ8QuyqS',
  stages: ['HB5YRN0UaRwJgywH1fBa', 'eJl6TSnV1qgHi8XG8VqU', 'FfmWmY9wfo93PkbzB08V'],
  activateCert: '25 04 2021 18:00',
  liveEventId: '40ed212b-5a07-40fc-863c-637ee80203af',
};
